<template lang="pug">
  .verify-billing
    v-layout.my-6
      y-dialog(v-model='isLoading' persistent width='300')
        v-card(v-if="!hasResult" color='primary' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('processing_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('processing_text') }}

        v-card(v-if="isSuccess" color='success' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('success_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('success_text') }}

        v-card(v-if="isError" color='error' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('error_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('error_text') }}

</template>

<script>
import { setOptions, bootstrap } from 'vue-gtag'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'VerifyPayment',
  props: ['lead'],
  data: () => ({
    isVerifying: true,
    isLoading: true,
    hasResult: false,
    isSuccess: false,
    isError: false,
    verifyingInterval: null,
    tryCount: 0,
    reDirectUrl: '/admin/dashboard'
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    })
  },
  mounted () {

    this.tryCount = 1
    this.verifyingInterval = setInterval(() => {
      this.$axios.get(`/companies/${this.company.id}/`)
      .then(resp => {
        if (resp.data.billing_verified === true) {
          this.updateCompany(resp.data)
          this.trackGtag()
          this.trackPixel()
          this.$axios.post(`/companies/${this.company.id}/attribute_affiliate/`, { type: 'signup' })
          this.isVerifying = false
          clearInterval(this.verifyingInterval)
          this.showResult(true)
        }
      })
      .catch(() => {})
      .finally(() => {
        if (this.tryCount >= 5 && this.isVerifying) {
          this.isVerifying = false
          clearInterval(this.verifyingInterval)
          this.showResult(false)
        }
        this.tryCount++
      })
    }, 1500)
  },
  methods: {
    ...mapActions(['updateCompany']),
    showResult (result) {
      this.hasResult = true
      if (result) {
        this.isSuccess = true
      } else {
        this.isError = true
      }
      setTimeout(() => {
        location.href = this.reDirectUrl
      }, 2000)
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.event('sign_up')
      })
    },
    trackPixel () {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'StartTrial', {
        value: '0.00',
        currency: 'MYR'
      })
    }
  }
}
</script>

<style scoped>
.header {
  background: #F8F9FC;
  padding: 16px;
}
.content {
  padding: 16px;
}
</style>

<i18n>
{
  "en": {
    "processing_title": "Verifying payment...",
    "processing_text": "Please wait and do not close or refresh this page",
    "success_title": "Thank you!",
    "success_text": "Your payment is successful",
    "error_title": "Ops..",
    "error_text": "Your payment did not go through. Please try again later."
  },
   "id": {
    "processing_title": "Verifikasi pembayaran...",
    "processing_text": "Sila tunggu dan jangan tutup halaman ini",
    "success_title": "Terima kasih!",
    "success_text": "Pembayaran berjaya",
    "error_title": "Ops..",
    "error_text": "Pembayaran gagal. Sila cuba lagi nanti."
  }
}
</i18n>
